import { Box, Typography, Avatar } from "@mui/material";
import { Home as HomeIcon, Business } from "@mui/icons-material";
import { SwitchForm } from "../common/SwitchForm";

export const ServicesLayout = ({
  sx,
  services = [],
  onChangedServicesChange,
  title,
  isLoading,
}) => {
  const isResidential = title?.toLowerCase().includes("residential");

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 3, sm: 4 },
        py: { xs: 3, sm: 4 },
        opacity: isLoading ? 0.6 : 1,
        pointerEvents: isLoading ? "none" : "auto",
        transition: "all 0.2s ease",
        ...sx,
      }}
    >
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Avatar
          sx={{
            width: 56,
            height: 56,
            backgroundColor: isResidential ? "var(--fx-surface-muted, #F1F5F9)" : "var(--fx-colors-info-100, #DBEAFE)",
            mx: "auto",
            mb: 2,
          }}
        >
          {isResidential ? (
            <HomeIcon sx={{ fontSize: 28, color: "#2e7d32" }} />
          ) : (
            <Business sx={{ fontSize: 28, color: "#0277bd" }} />
          )}
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mx: "auto" }}>
          {isResidential
            ? "Select the cleaning services you offer for homes and apartments"
            : "Choose the professional cleaning services you provide for businesses"}
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          borderRadius: 2,
          p: { xs: 2, sm: 3 },
          border: "1px solid var(--fx-surface-border, #E2E8F0)",
          minHeight: 200,
        }}
      >
        <SwitchForm
          checkedState={services}
          title="Available Services"
          onChangedServicesChange={onChangedServicesChange}
        />
      </Box>
    </Box>
  );
};
